import React, { useState } from 'react';
import { EyeOff, Eye, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../lib/api';
import { useAuth } from '../contexts/AuthContext';

// Investor mode (Talu, 10.10.2026): server-side pseudonymisation of every API response for this account.
// Switching reloads the app so nothing real stays cached in memory.
export const toggleInvestorMode = async (on, setBusy) => {
  setBusy && setBusy(true);
  try {
    await api.setInvestorMode(on);
    toast.success(on ? 'Investor-Modus aktiviert — App wird neu geladen' : 'Investor-Modus beendet — App wird neu geladen');
    setTimeout(() => window.location.reload(), 500);
  } catch (e) {
    toast.error(e?.response?.data?.detail || 'Investor-Modus konnte nicht geschaltet werden');
    setBusy && setBusy(false);
  }
};

export const InvestorModeButton = ({ className = '' }) => {
  const { isAdmin, investorMode } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!isAdmin) return null;
  return (
    <button onClick={() => toggleInvestorMode(!investorMode, setBusy)} disabled={busy} data-testid="investor-mode-toggle"
      data-active={investorMode ? 'true' : 'false'}
      title={investorMode ? 'Investor-Modus beenden (echte Daten wieder anzeigen)' : 'Investor-Modus: alle Firmen-, Personen- und Kontaktdaten pseudonymisieren, Downloads sperren'}
      className={`relative h-7 w-7 p-0 inline-flex items-center justify-center rounded-md transition-colors text-muted-foreground hover:text-foreground ${className}`}>
      {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : investorMode ? <Eye className="w-3.5 h-3.5" /> : <EyeOff className="w-3.5 h-3.5" />}
      {investorMode && !busy && <span data-testid="investor-mode-dot" className="absolute top-1 right-1 w-1.5 h-1.5 rounded-full bg-amber-400/80" />}
    </button>
  );
};
